import * as React from 'react';
import { styled } from '@mui/material/styles';
// eslint-disable-next-line import/named
import Checkbox from '@mui/material/Checkbox';

interface BpIconProps {
  customRadius?: any;
}

interface BpCheckIcon {
  selectedBackgroundColor?: string
}

const BpIcon = styled('span')<BpIconProps>(({ theme, customRadius, ...props }) => {
  return {
    borderRadius: customRadius !== undefined ? customRadius : 2,
    width: 16,
    height: 16,
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 0 0 1px rgb(16 22 26 / 40%)'
        : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundImage:
      theme.palette.mode === 'dark'
        ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
        : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background:
        theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
    },
  };
});

const BpCheckedIcon = styled(BpIcon)<BpCheckIcon>(({ theme, selectedBackgroundColor, ...props }) => {
  return {
    backgroundColor: selectedBackgroundColor ? selectedBackgroundColor : '#2B74D8',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    boxShadow: 'none',
    '&::before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: selectedBackgroundColor ? selectedBackgroundColor : '#2B74D8',
    },
  }
});

// Inspired by blueprintjs
function BpCheckbox(props) {
  return (
    <Checkbox
      sx={{
        padding: 0,
        '&:hover': { bgcolor: 'transparent' },
      }}
      disableRipple
      color="default"
      style={{ padding: 0, margin: 0 }}
      checkedIcon={<BpCheckedIcon selectedBackgroundColor={props.selectedBackgroundColor} />}
      icon={<BpIcon customRadius={props.borderRadius} />}
      inputProps={{ 'aria-label': 'Checkbox demo' }}
      {...props}
    />
  );
}

interface ICustomizedCheckboxProps {
  checked?: boolean;
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  className?: string;
  style?: React.CSSProperties;
  borderRadius?: number
  selectedBackgroundColor?: string
}

export default function CustomizedCheckbox({
  checked,
  handleChange = undefined,
  className,
  style = {},
  ...props
}: ICustomizedCheckboxProps) {
  return (
    <BpCheckbox
      checked={checked}
      style={style}
      className={className}
      onChange={handleChange}
      {...props}
    />
  );
}
